import { useState } from "react";
import {
  Modal,
  Button,
  Select,
  Form,
  Input,
  Upload,
  Row,
  Col,
  Image,
  Steps,
  InputNumber,
  Divider,
  Checkbox,
  Popover,
  Space,
  Avatar,
  message,
  Tooltip,
  Typography,
} from "antd";
import {
  UploadOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  FileZipOutlined,
  LoadingOutlined,
  CloseOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { observer } from "mobx-react";
import { useMobxStores } from "../../stores/stores";
import ThreeDModelCover from "./ItemComponents/ThreeDModelCover";
import FileModelViewer from "./FileModelViewer";
import JSZip from "jszip";
import "./CreateItemModal.css";

const { Option } = Select;

export const types = [
  {
    label: "software",
    value: "software",
    format: ".zip, .dmg",
  },
  {
    label: "3D",
    value: "3D",
    format: ".obj, .fbx, .stl, .glb, .zip",
  },
  {
    label: "dataset",
    value: "dataset",
    format: ".csv, .zip, .json",
  },
  {
    label: "text",
    value: "text",
    format: ".txt, .pdf, .docx",
  },
  {
    label: "Massive Open Online Course (MOOC)",
    value: "MOOC",
  },
];

const CreateItemModal = () => {
  const { userStore, styleStore, marketplaceStore, errorStore } =
    useMobxStores();
  const [previewImage, setPreviewImage] = useState(null);
  const [previewSoftware, setPreviewSoftware] = useState(null);
  const [chooseNetworkIsDisabled, setChooseNetworkIsDisabled] = useState(false);
  const [isNetworkSelected, setIsNetworkSelected] = useState(false);
  const [preview, setPreview] = useState(false);
  const [preview3D, setPreview3D] = useState(null);
  const [current, setCurrent] = useState(0);
  const [unlockableContent, setUnlockableContent] = useState(false);
  const [NFT, setNFT] = useState(false);
  const [displayImage, setDisplayImage] = useState(null);
  const [software, setSoftware] = useState(null);
  const [moocURL, setMoocURL] = useState(null);
  const [type, setType] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [urlEnabledNext, setUrlEnabledNext] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [form_nft] = Form.useForm();
  const [form_item] = Form.useForm();
  const [priceLabel, setPriceLabel] = useState("");
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);

  const contentStyle = {
    lineHeight: "260px",
    textAlign: "center",
    marginTop: 16,
  };

  const onTypeChanged = (e) => {
    setType(e);
  };

  const resetForm = (form) => {
    form.resetFields();
    setType(null);
  };

  const onChangeUnlockableContent = (e) => {
    setUnlockableContent(!unlockableContent);
  };

  const onCreateItem = async (fields) => {
    setPreviewImage(null);
    setPreview(false);
    const postData = new FormData();
    if (displayImage) {
      postData.append("display_image", displayImage.file.originFileObj);
    }
    postData.append("owner", userStore.user.id);
    fields.name && postData.append("name", fields.name);
    NFT && postData.append("nft", marketplaceStore.NFT.id);
    fields.description && postData.append("description", fields.description);
    type && postData.append("type", type);

    fields.tags?.map((item) => {
      postData.append("tags", item);
    });

    fields.unlockable_content &&
      postData.append("unlockable_content", fields.unlockable_content);
    fields.external_link &&
      postData.append("external_link", fields.external_link);
    postData.append("source", marketplaceStore.source?.id);
    try {
      await marketplaceStore.CreateMarketplaceItem(postData);
    } catch (error) {
      console.error(error);
      message.error(errorMessage);
    }
    form_item.resetFields();
    setCurrent(0);
    setUrlEnabledNext(false);
    setSoftware(null);
    setMoocURL(null);
    setFileName(null);
    setType(null);
    marketplaceStore.sourceIsUploaded = false;
    marketplaceStore.sourceIsUploading = false;
  };

  const onCreateNFT = (fields) => {
    fields.creator = localStorage.getItem("metaMask");
    fields.chainid = window.ethereum.networkVersion;
    fields.legacy = false;
    marketplaceStore.CreateNFT(fields);

    setCurrent(current + 1);
    form_nft.resetFields();
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const OnNextClick = () => {
    let mediaSource = marketplaceStore.source_link;

    if (type === "software" && software) {
      mediaSource = software;
    } else if (type === "MOOC" && moocURL) {
      mediaSource = moocURL;
    }

    const values = {
      type: type === "MOOC" ? "mooc" : type,
      media: mediaSource,
    };

    if (current === 0 || (current === 1 && !NFT)) {
      marketplaceStore.CreateSource(values);
    }

    setCurrent(current + 1);
  };

  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      marketplaceStore.setIsMarketplaceCreateModalOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleCancel = () => {
    marketplaceStore.setIsMarketplaceCreateModalOpen(false);
    setCurrent(0);
    marketplaceStore.setNFT({ name: "", price: "", license: "", sypply: "" });
    if (preview || previewImage) {
      setPreview(null);
      setPreviewImage(null);
      setPreview3D(null);
      setPreviewSoftware(null);
    }
    setType(null);
    setFileName(null);
    setSoftware(null);
    setMoocURL(null);
    setErrorMessage(null);
    setUrlEnabledNext(false);
    marketplaceStore.sourceIsUploaded = false;

    form_item && resetForm(form_item);
    current === 2 && NFT && resetForm(form_nft);
    setNFT(false);
  };

  const getBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(new Error(error));
    });
  };

  const onRemove = () => {
    setDisplayImage(null);
    setPreview(false);
    setPreviewImage(null);
    setPreview3D(null);
    setPreviewSoftware(null);
    setType(null);
    form_item.resetFields();
  };

  const handleCover = async (file) => {
    if (file) {
      setDisplayImage(file);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.file.originFileObj);
      }
    }
    setPreviewImage(file.url || file.preview);
    setImageName(file.file.name);
  };

  const SUPPORTED_MODELS = [".obj", ".fbx"];

  const handleBeforeUpload = async (file) => {
    const maxSizeInBytes = 100 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      message.error("File exceeds upload size limit");
      return false;
    }

    if (type === "3D") {
      if (file.name.toLowerCase().endsWith(".zip")) {
        const zip = new JSZip();
        const contents = await zip.loadAsync(file);
        const filesInZip = Object.keys(contents.files);

        const hasModelFile = filesInZip.some((filename) =>
          SUPPORTED_MODELS.some((ext) => filename.toLowerCase().endsWith(ext)),
        );
        if (!hasModelFile) {
          message.error(
            "Error: folder does not contain any .obj or .fbx files",
          );
          return false;
        }
      }

      const postData = new FormData();
      postData.append("file", file);
      await marketplaceStore.AddSourceToIPFS(postData);
      setPreview3D(file);
      setPreview(true);
      setFileName(file.name);
      return false;
    }

    if (type === "software") {
      setPreviewSoftware(file.name);
      setFileName(file.name);
    }

    const postData = new FormData();
    postData.append("file", file);
    await marketplaceStore.AddSourceToIPFS(postData);
    return false;
  };

  const handleRemoveImage = () => {
    setDisplayImage(null);
  };

  const getPriceLabel = async (chainId) => {
    const label = `Price ${chainId === 11155111 ? "(ETH)" : "(MATIC)"}`;
    setPriceLabel(label);
  };

  const OnNetworkChange = async (chainId) => {
    if (window.ethereum.networkVersion !== chainId) {
      setChooseNetworkIsDisabled(true);
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: `0x${chainId.toString(16)}` }],
        });
        await userStore.GetApprovalCheck({
          account: localStorage.getItem("metaMask"),
          chainid: chainId,
        });

        errorStore.setMessage("Network Changed");
        errorStore.setInfo(true);
        setChooseNetworkIsDisabled(false);
        setIsNetworkSelected(true);
      } catch (err) {
        console.log(err);

        if (err.code === 4902) {
          setChooseNetworkIsDisabled(true);
          await window.ethereum.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainName: "Amoy Testnet",
                chainId: `0x${chainId.toString(16)}`,
                nativeCurrency: {
                  name: "Matic",
                  decimals: 18,
                  symbol: "MATIC",
                },
                rpcUrls: ["https://rpc-amoy.polygon.technology/"],
              },
            ],
          });
          setChooseNetworkIsDisabled(false);
        } else {
          errorStore.setMessage(err.message);
          errorStore.setError(true);
          setChooseNetworkIsDisabled(false);
        }
      }
    }
    getPriceLabel(chainId);
  };

  const handleMoocLinkChange = (url) => {
    let isValidUrl = false;
    try {
      const parsed = new URL(url);
      isValidUrl =
        (parsed.protocol === "http:" || parsed.protocol === "https:") &&
        /^([a-z0-9-]+\.)+[a-z]{2,}$/i.test(parsed.hostname);
    } catch {
      isValidUrl = false;
    }
    setUrlEnabledNext(false);
    if (url === "") {
      setErrorMessage("");
      setMoocURL(null);
    } else if (isValidUrl) {
      setErrorMessage("");
      setMoocURL(url);
      setUrlEnabledNext(true);
    } else {
      setMoocURL(null);
      setErrorMessage("Enter a valid URL");
    }
  };

  const handleSoftwareLinkChange = (url) => {
    let res = /^(https:\/\/)(www\.)?(github\.com|gitlab\.com)(\/.*)?$/i.test(
      url,
    );

    setUrlEnabledNext(false);
    if (url === "") {
      setErrorMessage("");
      setSoftware(null);
    } else if (res) {
      setErrorMessage("");
      setSoftware(url);
      setUrlEnabledNext(true);
    } else {
      setSoftware(null);
      setErrorMessage("Enter a valid URL");
    }
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
        padding: "16px",
      }}
      type="button"
    >
      {marketplaceStore.sourceIsUploading ? (
        <LoadingOutlined />
      ) : (
        <PlusOutlined />
      )}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Display Image
      </div>
    </button>
  );

  const tags = marketplaceStore.tags;

  const networks = [
    {
      label: "Sepolia (Ethereum Testnet)",
      value: 11155111,
      avatar_url: marketplaceStore.ethereum_icon,
      description:
        "Ethereum is the most decentralised and popular blockchain network. This network is a great choice for those who would like to reach a wider audience. The costs in this network can be relatively high.  Learn more at the FAQ.",
    },
    {
      label: "Amoy  (Polygon Testnet)",
      value: 80002,
      avatar_url: marketplaceStore.polygon_icon,
      description:
        "Polygon network is based on Ethereum and has been optimised in regards to speed and cost. Great choice for those who would wish to keep the costs low. Learn more at the FAQ.",
    },
  ];
  const onButtonClick = () => {
    const name = form_nft.getFieldValue("name");
    form_item.setFieldsValue({
      name,
    });
  };

  const steps = NFT
    ? [
        {
          title: "Upload",
        },
        {
          title: "Distribution",
        },
        {
          title: "NFT",
        },
        {
          title: "Marketplace Listing",
        },
      ]
    : [
        {
          title: "Upload",
        },
        {
          title: "Distribution",
        },

        {
          title: "Marketplace Listing",
        },
      ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  return (
    <div>
      <Modal
        forceRender
        title="Create Item"
        open={marketplaceStore.IsMarketplaceCreateModalOpen}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        width={"70%"}
        style={{ textAlign: "center", height: "100%", maxWidth: "900px" }}
        className="create-item-modal"
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => setCurrent(current - 1)}
            disabled={current === 0}
          >
            Previous
          </Button>,
          <Button
            key="link"
            onClick={() => OnNextClick()}
            disabled={
              current === 3 ||
              (current === 0 && type === null) ||
              (!NFT && current === 2) ||
              (NFT && current === 2) ||
              chooseNetworkIsDisabled ||
              !(
                (type &&
                  marketplaceStore.sourceIsUploaded &&
                  !marketplaceStore.sourceIsUploading) ||
                urlEnabledNext
              ) ||
              (current === 1 && NFT && !isNetworkSelected)
            }
          >
            Next
          </Button>,
        ]}
      >
        {!marketplaceStore.marketplaceItemIsCreating ? (
          <>
            <Steps current={current} items={items} responsive={true} />
            <div style={contentStyle}>{steps[current].content}</div>
            <Form
              name="create_items"
              initialValues={{
                remember: true,
              }}
              onFinish={onCreateItem}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
              size="large"
              form={form_item}
            >
              {/* step 1 */}
              {current === 0 && (
                <Form.Item
                  label="Select the type of asset you want to publish"
                  name="type"
                  rules={[
                    {
                      required: false,
                      message: "Please input your type!",
                    },
                  ]}
                >
                  <Select
                    className="small-placeholder"
                    placeholder={"Type"}
                    onChange={(e) => onTypeChanged(e)}
                    disabled={
                      marketplaceStore.sourceIsUploaded || software || moocURL
                    }
                  >
                    {types.map((item, index) => {
                      return (
                        <Option key={index} value={item.value}>
                          {item.label}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              )}
              {current === 0 && (
                <Row gutter={[20, 20]} align={"top"} justify={"space-around"}>
                  <Col span={24} md={24} sm={24} lg={24} xxl={24}>
                    <p>
                      {marketplaceStore.sourceIsUploading && (
                        <b style={{ color: styleStore.primaryColor }}>
                          Wait, your file is uploading...
                        </b>
                      )}
                    </p>
                    <Row>
                      <Upload
                        name="avatar"
                        listType="picture-card"
                        showUploadList={false}
                        onChange={(file) => handleCover(file)}
                        disabled={!type || previewImage}
                        customRequest={() => {}}
                        accept=".jpg, .png"
                      >
                        {previewImage ? (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              position: "relative",
                            }}
                          >
                            <Image
                              src={previewImage}
                              alt="avatar"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                            <button
                              onClick={handleRemoveImage}
                              style={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                border: "none",
                                background: "none",
                                padding: 0,
                                margin: "4px",
                                zIndex: 1,
                                cursor: "pointer",
                              }}
                            >
                              <CloseOutlined
                                style={{ fontSize: "16px", color: "red" }}
                              />
                            </button>
                          </div>
                        ) : (
                          uploadButton
                        )}
                      </Upload>
                    </Row>
                    {type !== "software" && type !== "MOOC" && (
                      <Form.Item
                        label={"Upload your file"}
                        name="display_image"
                        rules={[
                          {
                            required: false,
                            message: "Please choose a file!",
                          },
                        ]}
                        style={{ alignItems: "center" }}
                      >
                        {!marketplaceStore.sourceIsUploading && (
                          <div>
                            <p style={{ color: styleStore.primaryColor }}>
                              {fileName}
                            </p>
                          </div>
                        )}
                        <div style={{ color: "#c9c8c8" }}>Limit 100MB</div>
                        <Upload
                          disabled={type === null}
                          onRemove={() => onRemove()}
                          style={{
                            alignItems: "center",
                            width: "100%",
                            minWidth: "auto",
                          }}
                          maxCount={1}
                          showPreviewIcon={true}
                          showUploadList={marketplaceStore.sourceIsUploading}
                          customRequest={() => {}}
                          beforeUpload={(file) => handleBeforeUpload(file)}
                          accept={
                            type === "dataset"
                              ? ".csv, .zip, .json"
                              : type === "text"
                                ? ".txt, .pdf, .docx"
                                : ".obj, .fbx, .stl, .glb, .zip"
                          }
                        >
                          <div>
                            <Button
                              disabled={type === null}
                              icon={<UploadOutlined />}
                              className="select_btn"
                            >
                              {type === null
                                ? "Select type"
                                : "Click to Upload"}
                            </Button>
                          </div>
                        </Upload>
                        {type && (
                          <div className="accept-types">
                            {" "}
                            Acceptable file formats:{" "}
                            {types.find((t) => t.label === type)?.format}
                          </div>
                        )}
                      </Form.Item>
                    )}
                    {type === "3D" && (
                      <ThreeDModelCover
                        onRemove={onRemove}
                        handleCover={handleCover}
                        previewImage={previewImage}
                        imageName={imageName}
                      />
                    )}
                    {type === "software" && (
                      <>
                        <Row gutter={[0, 8]}>
                          <Col>Please provide a link to the software:</Col>
                        </Row>
                        <Row gutter={[0, 8]}>
                          <Col span={24} style={{ marginBottom: "16px" }}>
                            <Input
                              type="url"
                              placeholder="Enter a Gitlab or Github Link"
                              onChange={(e) =>
                                handleSoftwareLinkChange(e.target.value)
                              }
                              disabled={previewSoftware}
                            />
                            {errorMessage && (
                              <div style={{ color: "red" }}>{errorMessage}</div>
                            )}
                          </Col>
                        </Row>
                        <Row justify="center" align="middle" gutter={[0, 8]}>
                          <Col
                            justify="center"
                            align="middle"
                            style={{ marginBottom: "16px" }}
                          >
                            Or Upload your file:
                          </Col>
                        </Row>
                        <Row justify="center" align="middle" gutter={[0, 8]}>
                          <Col>
                            {previewSoftware != null &&
                              !marketplaceStore.sourceIsUploading && (
                                <div>
                                  <FileZipOutlined />
                                  <p style={{ color: styleStore.primaryColor }}>
                                    {fileName}
                                  </p>
                                </div>
                              )}
                            <div style={{ color: "#c9c8c8" }}>Limit 100MB</div>
                            <Upload
                              beforeUpload={(file) => handleBeforeUpload(file)}
                              customRequest={() => {}}
                              accept=".zip, .dmg"
                              showPreviewIcon={true}
                              showUploadList={
                                marketplaceStore.sourceIsUploading
                              }
                              maxCount={1}
                              disabled={software || errorMessage}
                            >
                              <Button
                                icon={<UploadOutlined />}
                                style={{
                                  opacity: software || errorMessage ? 0.5 : 1,
                                  pointerEvents:
                                    software || errorMessage ? "none" : "auto",
                                }}
                              >
                                Click to Upload
                              </Button>
                            </Upload>

                            <div className="accept-types">
                              Acceptable file formats: .zip, .dmg
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                    {type === "MOOC" && (
                      <>
                        <Row gutter={[0, 8]}>
                          <Col style={{ marginTop: "16px" }}>
                            Please provide a link to the MOOC:
                          </Col>
                        </Row>
                        <Row gutter={[0, 8]}>
                          <Col span={24} style={{ marginBottom: "16px" }}>
                            <Input
                              type="url"
                              placeholder="Enter a valid url"
                              onChange={(e) =>
                                handleMoocLinkChange(e.target.value)
                              }
                              disabled={previewSoftware}
                            />
                            {errorMessage && (
                              <div style={{ color: "red" }}>{errorMessage}</div>
                            )}
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                  <Col span={24} md={24} sm={24} lg={24} xxl={24}>
                    {preview && displayImage && type === "image" && (
                      <Image
                        preview={false}
                        width={"400px"}
                        height={"400px"}
                        style={{ textAlign: "center" }}
                        src={previewImage}
                      />
                    )}
                    {preview3D && type === "3D" && (
                      <FileModelViewer file={preview3D} />
                    )}
                  </Col>
                </Row>
              )}
              {/* step 2 */}
              {current === 1 && (
                <>
                  {NFT && (
                    <Form.Item
                      label="Choose Network"
                      name="chainId"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Network!",
                        },
                      ]}
                    >
                      <div style={{ color: "#ff5959" }}>
                        * You may need to approve this transaction to enable NFT
                        sales.
                      </div>
                      <Select
                        style={{ textAlign: "left" }}
                        placeholder={"network"}
                        onChange={(chainId) => OnNetworkChange(chainId)}
                        disabled={
                          chooseNetworkIsDisabled ||
                          !marketplaceStore.metaMaskIsConnected
                        }
                        loading={chooseNetworkIsDisabled}
                      >
                        {networks.map((item, index) => {
                          return (
                            <Option key={index} value={item.value}>
                              <Space>
                                <Avatar src={item.avatar_url}></Avatar>
                                {item.label}
                                <Popover content={item.description}>
                                  <InfoCircleOutlined
                                    style={{ fontSize: "20px" }}
                                  />
                                </Popover>
                              </Space>
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  )}

                  <p>Will you publish your work as NFT or Free item?</p>
                  <Space
                    direction="horizontal"
                    split={true}
                    wrap={true}
                    size={"middle"}
                  >
                    <Popover
                      content={
                        !marketplaceStore.metaMaskIsConnected
                          ? "Please connect to metaMask first!"
                          : "Create NFT item"
                      }
                    >
                      <Checkbox
                        disabled={!marketplaceStore.metaMaskIsConnected}
                        checked={NFT}
                        onChange={() => {
                          setNFT(true);
                          if (type === "MOOC") {
                            setUnlockableContent(true);
                          }
                        }}
                      >
                        NFT
                      </Checkbox>
                    </Popover>
                    <Popover content={"Create Free item"}>
                      <Checkbox checked={!NFT} onChange={() => setNFT(false)}>
                        Free
                      </Checkbox>
                    </Popover>
                  </Space>
                </>
              )}

              {/* step 4 */}

              {(current === 3 && NFT === true) ||
              (current === 2 && NFT === false) ? (
                <>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please input your name!",
                      },
                    ]}
                  >
                    <Input placeholder="Name" maxLength={100} showCount />
                  </Form.Item>

                  <Form.Item
                    label="Description"
                    name="description"
                    rules={[
                      {
                        required: false,
                        message: "Please input your description!",
                      },
                    ]}
                  >
                    <Input placeholder="Description" />
                  </Form.Item>

                  <Form.Item
                    label="Tags"
                    name="tags"
                    rules={[
                      {
                        required: false,
                        message: "Please input your tag!",
                      },
                    ]}
                  >
                    <Select placeholder={"Tags"} mode="tags">
                      {tags.map((item, index) => {
                        return (
                          <Option key={index} value={item.name}>
                            {item.name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="External link"
                    name="external_link"
                    rules={[
                      {
                        required: false,
                        message: "Please input your external_link!",
                        type: "url",
                      },
                    ]}
                  >
                    <Input placeholder="External link" />
                  </Form.Item>
                  {NFT && (
                    <Checkbox
                      onChange={onChangeUnlockableContent}
                      defaultChecked={type === "MOOC"}
                      disabled={type === "MOOC"}
                    >
                      Unlockable Content
                    </Checkbox>
                  )}
                  {unlockableContent && (
                    <Form.Item
                      label="Unlockable Content"
                      name="unlockable_content"
                      rules={[
                        {
                          required: type === "MOOC",
                          message: "Please input your unlockable content!",
                          type: "string",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Unlockable Content"
                        maxLength={1000}
                        showCount
                      />
                    </Form.Item>
                  )}
                  <Divider />
                  <Form.Item
                    wrapperCol={{
                      offset: 8,
                      span: 24,
                    }}
                  >
                    <Button type="primary" htmlType="submit">
                      Create Item
                    </Button>
                  </Form.Item>
                </>
              ) : (
                ""
              )}
            </Form>

            {current === 2 && NFT && (
              <Form
                name="create_nft"
                onFinish={onCreateNFT}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                layout="vertical"
                size="large"
                form={form_nft}
              >
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input name!",
                    },
                  ]}
                >
                  <Input placeholder="Name" maxLength={100} showCount />
                </Form.Item>

                <Form.Item
                  label={priceLabel}
                  name="price"
                  rules={[
                    {
                      required: true,
                      message: "Please input price!",
                      type: "number",
                    },
                  ]}
                >
                  <InputNumber style={{ width: "100%" }} placeholder="Price" />
                </Form.Item>

                <Form.Item
                  label="License"
                  name="license"
                  rules={[
                    {
                      required: true,
                      message: "Please input license!",
                    },
                  ]}
                  initialValue={
                    type === "MOOC"
                      ? marketplaceStore.license.find(
                          (license) =>
                            license.name === "EIT Manufacturing Academy",
                        )?.id
                      : undefined
                  }
                  style={{ marginBottom: type === "MOOC" ? 8 : "initial" }}
                >
                  <Select
                    style={{ textAlign: "left" }}
                    placeholder={"License"}
                    disabled={type === "MOOC"}
                  >
                    {marketplaceStore.license.map((item, index) => {
                      return (
                        <Option key={index} value={item.id}>
                          {item.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {type === "MOOC" && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "24px",
                        gap: "4px",
                      }}
                    >
                      <InfoCircleOutlined
                        style={{ fontSize: "16px", color: "#2a93d3" }}
                      />
                      <Typography
                        style={{
                          textAlign: "start",
                          fontWeight: "500",
                          color: "#2a93d3",
                        }}
                        onClick={() => setIsDisclaimerOpen(true)}
                      >
                        Disclaimer
                      </Typography>
                    </div>

                    <Modal
                      open={isDisclaimerOpen}
                      footer={[
                        <Button
                          type="primary"
                          onClick={() => setIsDisclaimerOpen(false)}
                        >
                          I understand
                        </Button>,
                      ]}
                      onCancel={() => setIsDisclaimerOpen(false)}
                      className="disclaimer-modal"
                      title={
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "32px",
                            color: "#000080",
                            backgroundColor: "#d9d9d9",
                            marginBottom: "20px",
                          }}
                        >
                          Disclaimer
                        </div>
                      }
                      width={"1000px"}
                    >
                      {
                        marketplaceStore.license.find(
                          (license) =>
                            license.name === "EIT Manufacturing Academy",
                        )?.description
                      }
                    </Modal>
                  </>
                )}
                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Tooltip
                    title="Enter a number greater than 1 to create a limited edition NFT."
                    backgroundColor="#00000000"
                  >
                    <QuestionCircleOutlined
                      style={{
                        color: "#989a9c",
                        marginRight: 8,
                        paddingTop: 8,
                        width: 20,
                      }}
                    />
                  </Tooltip>
                  <Form.Item
                    label="Amount"
                    name="supply"
                    rules={[
                      {
                        required: true,
                        message: (
                          <p style={{ color: "green" }}>Please input supply!</p>
                        ),
                        type: "integer",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="Amount"
                    />
                  </Form.Item>
                </Row>
                <Row
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Tooltip
                    title="The percentage from the resells to be returned to the original creator."
                    backgroundColor="#00000000"
                  >
                    <QuestionCircleOutlined
                      style={{
                        color: "#989a9c",
                        marginRight: 8,
                        paddingTop: 8,
                        width: 20,
                      }}
                    />
                  </Tooltip>
                  <Form.Item
                    label="Royalty"
                    name="royalty_value"
                    rules={[
                      {
                        required: false,
                        message: "Please input the royalties percentage!",
                        type: "number",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: "100%" }}
                      placeholder="Royalty (%)"
                      min={0}
                      max={100}
                      step={0.1}
                    />
                  </Form.Item>
                </Row>
                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 24,
                  }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={onButtonClick}
                  >
                    Create NFT
                  </Button>
                </Form.Item>
              </Form>
            )}
          </>
        ) : (
          <span className="loader" />
        )}
      </Modal>
    </div>
  );
};

export default observer(CreateItemModal);
